import PropTypes from 'prop-types';

export default PropTypes.shape({
  formatMessage: PropTypes.func.isRequired,
});
